module.exports = __webpack_public_path__ + "static/media/contact-hero-1-mobile.32293bfd.jpg";